import './styles/Footer.scss';

import { PropsWithChildren } from 'react';

import { useClassHelper } from '../../hooks/useClassHelper';

const componentName = 'c-Footer';

type Props = PropsWithChildren

export const Footer = ({ children }: Props) => {
  const c = useClassHelper(componentName);

  return (
    <footer className={componentName}>
      <div className={c('__content')}>
        <div className={c('__powered-by')}>
          {children}
        </div>
      </div>
    </footer>
  );
};
